import React from "react";
import { Button, Modal } from "react-bootstrap";
import './ConfirmationDialog.css';

export default function ConfirmationDialog(props) {

    return (
        <Modal id="ceConfirmationDialog" show={props.show} onHide={props.handleClose} centered >
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="content-title">
                        <span>{props.intl.formatMessage({ id: "ce_dialog_header_confirm" })}</span>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span>{props.intl.formatMessage({ id: props.message })}</span>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={props.register}>{props.intl.formatMessage({ id: props.btnText })}</Button>
                <Button variant="secondary" onClick={props.handleClose}>{props.intl.formatMessage({ id: "go_back" })}</Button>
            </Modal.Footer>
        </Modal>
    );
};